module.exports = __webpack_public_path__ + "img/equatorial_guinea.aba909f.webp";